<template lang="pug">
shListData(title="Órdenes" resolver="orders" keyData="order" component="shOrder")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Orders',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/order/Orders.vue